import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Post } from "../../../../Services/Server";
import Url from "../../../../Services/Url";
import Head from "../../../../Components/Head/Head";
import Form from "../../../../Components/Form/Form";
import { toast } from "react-toastify";
import "./AddAnnouncement.css";
import AddAnnouncementFormOptions from "../AnnouncementFormOptions";
import Utils from "../../../../Services/Utills";

const AddAnnouncement = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);

	const handleSave = (formData) => {
		setLoading(true);

		const dataObject = Utils.FormObject(formData);

		// The backend payload format
		const payload = {
			title: dataObject.title,
			message: dataObject.content,
			startDate: dataObject.startDate,
			endDate: dataObject.endDate,
			roleIds: dataObject.userConfiguration.map((id) => parseInt(id, 10)),
		};

		Post(Url.notification.create, payload)
			.then(() => {
				toast.success("Announcement created successfully!");
			})
			.catch((err) => {
				console.error("An error occurred while saving the announcement:", err);
				toast.error("Failed to create announcement. Please try again.");
			})
			.finally(() => {
				setLoading(false);
				navigate("../");
			});
	};

	return (
		<div className="add-announcement">
			<Head title="Create A New Announcement" />
			<div className="form-container">
				<h2 className="form-title">Announcement Details</h2>
				<Form onSubmit={handleSave}>{AddAnnouncementFormOptions}</Form>
			</div>
		</div>
	);
};

export default AddAnnouncement;
